// Import css
import '@/scss/main.scss';

// Import Bootstrap dropdown, with minimal related code to minimize bundle size
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';

// @ts-expect-error (Package has no types available)
void import('lite-youtube-embed');

// Mark active page in main menu
const activePageId = document.head.dataset['activePage'];
if (activePageId) {
  document.getElementById(activePageId)?.classList.add('active');
}

/*
 * navbar code ==================================================================
 * This manually toggles the multi-level dropdowns
 */
const subMenus = document.querySelectorAll<HTMLAnchorElement>('.dropdown-submenu-toggle');
for (const subMenu of subMenus) {
  subMenu.addEventListener('click', (e) => {
    const current = e.target as HTMLAnchorElement;
    // Open target submenu
    current.parentElement?.classList.add('active');
    current.nextElementSibling?.classList.add('d-block'); // Geef `display:block;`
    current.nextElementSibling?.classList.add('toggled');
    // Sluit alle andere submenus
    Array.from(subMenus)
      .filter((el) => el !== current) // Niet de huidige
      .forEach((el) => {
        el.parentElement?.classList.remove('active');
        el.nextElementSibling?.classList.remove('d-block');
        el.nextElementSibling?.classList.remove('toggled');
      });
    e.stopPropagation();
    e.preventDefault();
  });
}
